import { injectContextAsArray } from "@components/constructor";
import { useDailyGifts } from "@hooks/selectors/user/daily.selectors";
import { EGiftType, IGift, IItemGiftInfo } from "@interfaces/user/daily";
import { FC, PropsWithChildren, ReactNode, RefObject, useMemo } from "react";
import Slick, { Settings } from "react-slick";
import { useItems } from "@hooks/selectors/user/item.selectors";
import { DailyGiftProvider } from "./context";
import { InjectContextType } from "@interfaces/constructor/constructor";

interface DailyGiftsListProps {
    children: ReactNode;
    slider?: Settings;
    slider_ref?: RefObject<Slick>;
}

const DailyGiftsList = ({ children, slider, slider_ref }: DailyGiftsListProps) => {

    const gifts = useDailyGifts();

    const itemIds = gifts.filter(g => g.giftType === EGiftType.ItemGift).map(g => (g.giftInfo as IItemGiftInfo).itemId);
    useItems(itemIds);

    const data = useMemo<InjectContextType<IGift>[]>(() => gifts.map((gift) => {
        return {
            key: gift.id,
            value: gift,
            childData: {
                gift_type: gift.giftType,
                repeat: gift.repeat,
                is_assigned: gift.isAssigned,
                is_assigned_now: gift.isAssignedNow
            }
        }
    }), [gifts]);

    if (slider || slider_ref) {
        return (
            <Slick {...slider} ref={slider_ref}>
                {injectContextAsArray(data, DailyGiftProvider, children)}
            </Slick>
        )
    }

    return injectContextAsArray(data, DailyGiftProvider, children);
}

export default DailyGiftsList;
